import { createFileRoute } from "@tanstack/react-router";
import StatisticsView from "../../app/views/statistics/statisticsView";

export const Route = createFileRoute("/statistics/statistics")({
  component: StatisticsView,
});
